define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/heading/RefContainer"
], function(array,declare,RefContainer) {

	return declare(RefContainer, {
		getReferencedNodes: function(/*csi.def.Context*/ctx, /*csi.def.Heading*/h) {
			// summary: filters out test runs that don't reference this sample
			var testRuns = this.inherited(arguments);
			if (testRuns) {
				testRuns = array.filter(testRuns, function(testRun) {
					var rev = ctx.cache.getNode(testRun.CurrentRevision, true);
					return rev.TestRunSample == ctx.getNodeContextURL();
				});
			}

			return testRuns;
		}
	});
});